export default {
  LOAD_LIST_EVENT(state, data) {
    state.listaEvents = data;
  },
  PREPARE_TO_EDIT_EVENT(state, data) {
    state.event = data;
  },
  RESET_EVENT(state) {
    state.event = {
      nome: "",
      descricao: "",
      tipoEvento: {
        id: null,
        nome: "",
        ativo: true,
      },
      local: "",
      dataInicial: "",
      dataFinal: "",
      hora: null,
      horaFinal: null,
      qtoVaga: 0,
      publicoAlvo: "",
      status: "",
      ativo: true,
      temCobranca: false,
      valor: 0,
      tipoPagamentoRecebimento: {
        id: null,
        descricao: "",
      },
    };
  },
};
